import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export const Article = withAsync({
	loader: lazyForPaint(() => import(/* webpackChunkName: "article-page" */ './hocs')),
});
